import React, { Component } from 'react';
import styled from 'styled-components';
import Header from './_EmbedHeader';
import Iframe from './_NewIframeEmbedMobile';

const Wrapper = styled.div`
  ${'' /* border: 1px solid grey; */}
  ${'' /* background-color: #ccc; */}
  ${'' /* border-radius: 3px; */}
  height: ${props => {
    return props.window.height + 'px';
    }}
`

class MobileEmbed extends Component {
  render() {
    const headerHeight = 24;
    const styleProps = {
      height: (this.props.window.height - headerHeight - 6) + 'px',
      width: this.props.window.width + 'px',
      border: '1px solid lightgrey',
      borderTop: '0',
      // borderBottomLeftRadius: '5px',
      // borderBottomRightRadius: '5px'
    }
    return (
      <Wrapper window={this.props.window}>
        <Header
          height={headerHeight}
          imgsrc='/envelopeLogoRed.png'
          text='  Edit on Envelope'
        />
        <Iframe styleProps={styleProps} envelope={this.props.envelope}/>
      </Wrapper>
    )
  }
}

export default MobileEmbed



// WEBPACK FOOTER //
// ./src/_MobileEmbed.js